import React from 'react'
import LoginButton from '../LoginButton'
import Dropdown from '../AriaMenu/Dropdown'
import MenubarItem from '../AriaMenu/MenubarItem'
import Submenu from '../AriaMenu/Submenu'
import SubmenuItem from '../AriaMenu/SubmenuItem'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import '../../styles/index.scss'
import '../../styles/navbar/styles.scss'
import Icon from '../Icon/index'

const LoginMenuItem = inject('sessionStore')(observer(function LoginMenuItem (props) {
  const { REACT_APP_DASHBOARD_LINK, REACT_APP_ACCOUNT_LINK } = window.env
  const { sessionStore } = props

  if (!sessionStore.isLoggedIn) {
    return (<LoginButton type={MenubarItem} />)
  }

  return (
    <Dropdown className='navbar__dropdown'>
      <MenubarItem data-automation-name='dropdown-link' className='navbar__link navbar__link--button navbar__link--logged-in __username' href={REACT_APP_DASHBOARD_LINK}>{sessionStore.userName}
        <Icon className='accountLinkIcon' name='app-dashboard' />
      </MenubarItem>
      <Submenu className='navbar__submenu navbar__submenu--last'>
        <p className='navbar__submenu-heading'>Your Account</p>
        <div className='navbar__submenu-section navbar__submenu-section--top'>
          <ul className='navbar__submenu-items'>
            <li className='navbar__submenu-item'>
              <SubmenuItem data-automation-name='application-link' className='navbar__submenu-link' href={REACT_APP_DASHBOARD_LINK}>
                Applications
              </SubmenuItem>
            </li>
            <li className='navbar__submenu-item'>
              <SubmenuItem data-automation-name='account-link' className='navbar__submenu-link' href={REACT_APP_ACCOUNT_LINK}>
                Account
              </SubmenuItem>
            </li>
            <li className='navbar__submenu-item'>
              <SubmenuItem data-automation-name='loguut-link' className='navbar__submenu-link __logout' onClick={() => sessionStore.handleLogout()} tabIndex='0'>
                Log Out
              </SubmenuItem>
            </li>
          </ul>
        </div>
      </Submenu>
    </Dropdown>
  )
}))

LoginMenuItem.contextTypes = {
  session: PropTypes.object,
  user: PropTypes.object
}

export default LoginMenuItem
